<div class="main-div">
    <div class="col-12  flex flex-wrap">
        <h2>خشت</h2>
        <div class="col-12">
            <p>
                خشت و گل، در دستان هنرمندان یزدی به شاهکارهایی بی‌نظیر تبدیل شده‌اند. هر خشت، داستانی از تلاش و همت
                مردمانی است که به عشق سازگاری با محیط، خانه‌های خود را بنا کرده‌اند. بادگیرهای خانه‌های یزد، نه تنها یک
                عنصر معماری، بلکه تجسمی از فرهنگ و هویت این دیار به شمار می‌روند. بادگیرها خاطرات نسل‌ها را در آغوش
                گرفته‌اند.
            </p>
        </div>
        <div class="col-12 ">
            <!--            <video width="100%" controls>-->
            <!--                <source src="{{conf.getBaseUrl()+'lnd/file/stream-video-file?name=1.1.mp4' }}"-->
            <!--                        type="video/mp4">-->
            <!--            </video>-->
            <div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span>
                <iframe src="https://www.aparat.com/video/video/embed/videohash/pzd659z/vt/frame" allowFullScreen="true"
                        webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
            </div>
        </div>
    </div>
</div>